import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TableCellComponent } from '../../table/table.model';
import { PasfotoComponent } from '../../../pasfoto/pasfoto.component';

export type LeerlingCellData = {
	leerlingNummer: string;
	leerlingNaam: string;
	pasfoto: string;
};

@Component({
	selector: 'app-leerling-cell',
	templateUrl: './leerling-cell.component.html',
	styleUrls: ['./leerling-cell.component.scss'],
	imports: [PasfotoComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeerlingCellComponent implements TableCellComponent<LeerlingCellData> {
	data!: LeerlingCellData;
}
